import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../../App';

export const SyncFullMexPMTaskOperations = () => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `preventative-maintenance-task/sync-full`,
    {
      headers,
    }
  );
};
